import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import Button from '@repo/ui/button'
import { ChevronLeftIcon, GoalIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

import {
  createOrUpdateMissionToStaffTravelExpenses,
  updateMissionToStaffTravelExpensesCurrency
} from '../../api/mission-to-staffs/create-or-update-travel-expenses'
import { getMissionToStaff } from '../../api/mission-to-staffs/get-mission-to-staff'
import { getMissionToStaffTravelExpenses } from '../../api/mission-to-staffs/get-mission-to-staff-travel-expenses'
import { sendMissionToStaffTravelExpensesToLec } from '../../api/mission-to-staffs/send-travel-expenses-to-lec'
import LoadingScreen from '../../components/elements/loading/loading-screen'
import UserNavBar from '../../components/elements/nav-bar'
import TravelExpenses from '../../components/pages/travel-expenses/travel-expenses'
import { Paths } from '../../lib/constants/path'
import useAuth from '../../lib/hooks/use-auth'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { t } from '../../locale/utils'

export default function MissionToStaffTravelExpensesPage() {
  const id = useParams<{ id: string }>().id
  const { user } = useAuth()
  const { back } = useNavigator()

  const { data, isPending, refetch } = useQuery({
    queryKey: ['mission-to-staff', id],
    queryFn: () => {
      if (id) return getMissionToStaff(Number(id))
    },
    enabled: !!id
  })

  if (isPending) return <LoadingScreen />
  if (!data) return <Typography variant="text">Affected staff not found</Typography>

  return (
    <div className="flex flex-col gap-5">
      <UserNavBar
        title={t('staff.personal.space.missions')}
        icon={(props) => <GoalIcon {...props} color={tailwindColors.fushia.DEFAULT} />}
      />
      <Box className="px-5 py-6">
        <Button
          type="button"
          label="Retour"
          icon={ChevronLeftIcon}
          variant="secondary"
          onClick={() => {
            return back(Paths.STAFF_PERSONAL_SPACE_MISSIONS)
          }}
          className="mb-4"
        />
        <TravelExpenses
          id={data.id}
          updateTravelExpensesCurrency={(currency) =>
            updateMissionToStaffTravelExpensesCurrency({ id: data.id, currency })
          }
          mode={user.role === RoleEnum.ADMIN ? 'admin' : 'staff'}
          travelExpensesCurrency={data.travelExpensesCurrency}
          travelExpensesStatus={data.travelExpensesStatus}
          travelExpensesSentAt={data.travelExpensesSentAt}
          createOrUpdateTravelExpenses={createOrUpdateMissionToStaffTravelExpenses}
          sendTravelExpensesToLec={sendMissionToStaffTravelExpensesToLec}
          getTravelExpenses={getMissionToStaffTravelExpenses}
          onSuccess={async () => {
            await refetch()
          }}
        />
      </Box>
    </div>
  )
}
